import { bannerStyles } from "@insite/content-library/Widgets/Basic/Banner";
import { mediaQueriesBP } from "@waytek/Utilities/variables";
import { css } from "styled-components";

bannerStyles.wrapper = {
    ...bannerStyles.wrapper,

    css: css`
        ${bannerStyles.wrapper?.css}

        ${mediaQueriesBP.minMD} {
            width: calc(100% + 20px);
            margin-left: -10px;
        }

        ${mediaQueriesBP.maxMD} {
            width: 100vw;
            margin-left: calc(50% - 50vw);
        }
    `,
};
